import utils from '@/utils';
import { clone } from '@/utils/dataUtil';
import { STRUCTURES_API } from '@/api';

const state = {
  tableKey: -999,
  currentTableRow: null,
  tableData: [],
  tableConfig: {
    columns: [{
      prop: 'versionId', label: 'Version', sortable: true,
    }, {
      prop: 'shortName', label: 'Name', sortable: true,
    }, {
      prop: 'description', label: 'Description', sortable: true,
    }, {
      prop: 'marketName', label: 'Market', sortable: true,
    }, {
      prop: 'createdBy', label: 'Created By', sortable: true,
    }, {
      prop: 'createdDate', label: 'Created Date', sortable: true, dataType: 'datetime',
    }, {
      prop: 'updatedBy', label: 'Updated By', sortable: true,
    }, {
      prop: 'updatedDate', label: 'Updated Date', sortable: true, dataType: 'datetime',
    }],
  },
  nullTableRow: {
    id: -999,
    versionId: null,
    shortName: null,
    description: null,
    commodityName: 'POWER',
    marketName: null,
    activeFlag: true,
    createdBy: null,
    createdDate: null,
    updatedBy: null,
    updatedDate: null,
  },
};

const getters = {
  getTableConfig: (state) => state.tableConfig,
  getTableData: (state) => state.tableData,
  getCurrentRow: (state) => state.currentTableRow,
  getMarketList: (state, getters, rootState) => rootState.lookup.marketList,
};

const actions = {
  initialize({ dispatch }) {
    dispatch('lookup/fetchMarketList', null, { root: true });
    dispatch('loadTableData');
  },
  resetTable({ commit, state }) {
    commit('resetTable');
  },
  loadTableData({ commit }) {
    STRUCTURES_API.get('/market-product-types').then(({ data }) => {
      commit('loadTableData', data.marketProductTypes);
      this.$notify(`${data.marketProductTypes.length} Product Type(s) Loaded`, 'info');
    }).catch((err) => {
      this.$notify('Failed to Load Product Types', 'error');
    });
  },
  createTableRow({ commit }) {
    commit('createTableRow');
  },
  postMarketProductType({ state }, marketProductType) {
    STRUCTURES_API.post('/market-product-types', marketProductType).then(({ data }) => {
      state.tableData.push(data);
      this.$notify('Product Type Added', 'success');
    }).catch((err) => {
      this.$notify('Failed to Add Product Type', 'error');
    });
  },
  updateMarketProductType({ dispatch, commit, state }, marketProductType) {
    STRUCTURES_API.put(`/market-product-types/${marketProductType.id}`, marketProductType).then(({ data }) => {
      commit('updateMarketProductType', data);
      this.$notify('Product Type Updated', 'success');
    }).catch((err) => {
      this.$notify('Failed to Update Product Type', 'error');
    });
  },
  deleteTableRow({ dispatch, commit, state }) {
    STRUCTURES_API.delete(`/market-product-types/${state.currentTableRow.id}`).then(({ data }) => {
      commit('deleteTableRow');
      dispatch('currentTableRowChange', clone(state.nullTableRow));
      this.$notify('Product Type Removed', 'success');
    }).catch((err) => {
      this.$notify('Failed to Remove Product Type', 'error');
    });
  },
  currentTableRowChange({ commit }, currentRow) {
    commit('currentTableRowChange', currentRow);
  },
};

const mutations = {
  updateMarketProductType(state, marketProductType) {
    const rowIndex = state.tableData.findIndex(({ id }) => id === marketProductType.id);
    state.tableData.splice(rowIndex, 1, marketProductType);
  },
  currentTableRowChange(state, currentRow) {
    state.currentTableRow = currentRow;
  },
  resetTable(state) {
    state.tableData = [];
    state.currentTableRow = clone(state.nullTableRow);
  },
  loadTableData(state, marketProductTypes) {
    state.tableData = marketProductTypes;
  },
  createTableRow(state) {
    const marketProductType = clone(state.nullTableRow);
    marketProductType.id = state.tableKey++;
    marketProductType.versionId = 1;
    marketProductType.createdBy = this.getters['auth/getProfile'].userName;
    marketProductType.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = marketProductType;
  },
  deleteTableRow(state) {
    state.tableData = state.tableData.filter((marketProductType) => marketProductType.id !== state.currentTableRow.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};